import { NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Package, ClipboardList, Radio, Menu } from 'lucide-react'
import { cn } from '@/lib/utils'

interface Props {
  onMenuOpen: () => void
}

const MOBILE_NAV = [
  { to: '/dashboard', label: 'Home', icon: LayoutDashboard },
  { to: '/assets', label: 'Assets', icon: Package },
  { to: '/qr-scanner', label: 'Scan', icon: Radio, highlight: true },
  { to: '/work-orders', label: 'Orders', icon: ClipboardList },
]

export function MobileBottomNav({ onMenuOpen }: Props) {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-1">
        {MOBILE_NAV.map(({ to, label, icon: Icon, highlight }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-0.5 w-16 h-14 rounded-xl transition-colors',
                highlight && !isActive && 'relative',
                isActive
                  ? 'text-gold-600'
                  : 'text-gray-400 hover:text-navy-800'
              )
            }
          >
            {({ isActive }) => (
              <>
                {highlight ? (
                  <div className={cn(
                    'w-12 h-12 rounded-2xl flex items-center justify-center -mt-6 shadow-lg',
                    isActive ? 'bg-gold-500' : 'bg-navy-800'
                  )}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                ) : (
                  <Icon className="w-5 h-5" />
                )}
                <span className={cn(
                  'text-[10px] font-medium',
                  highlight && '-mt-0.5'
                )}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          onClick={onMenuOpen}
          className="flex flex-col items-center justify-center gap-0.5 w-16 h-14 rounded-xl text-gray-400 hover:text-navy-800 transition-colors"
        >
          <Menu className="w-5 h-5" />
          <span className="text-[10px] font-medium">More</span>
        </button>
      </div>
    </nav>
  )
}
